import { storage } from '@/utils/storage';

const localeKey = 'Locale';

const LocalesMap = new Map([
  ['en', 'en'],
  ['zh-CN', 'zh'],
  ['zh', 'zh'],
]);
const envBaseUrl = process.env.VUE_APP_BASE_URL;

const common = {
  namespaced: true,
  state: {
    deployType: 'saas',
    extensionInstalled: false,
    version: '',
    isAllowedIncognitoAccess: false,
    locale: storage.get(localeKey) || LocalesMap.get(navigator.language) || 'en',
    baseUrl: envBaseUrl && envBaseUrl !== '/' ? envBaseUrl : window.location.origin,
  },
  getters: {
    // need to update
    needToUpgrade: (state) => {
      if (!state.version) return false;

      const compareVersions = (v1, v2) => {
        const parts1 = v1.split('.').map(Number);
        const parts2 = v2.split('.').map(Number);
        for (let i = 0; i < 3; i++) {
          if (parts1[i] < parts2[i]) return true;
          if (parts1[i] > parts2[i]) return false;
        }
        return false;
      };
      return compareVersions(state.version, process.env.VUE_APP_EXTENSION_VERSION);
    },
    isAllowedIncognitoAccess: (state) => {
      return state.isAllowedIncognitoAccess;
    },
    locale: (state) => {
      return state.locale;
    },
    baseUrl: (state) => {
      return state.baseUrl;
    },
    isSaas: (state) => {
      return state.deployType === 'saas';
    },
  },
  mutations: {
    SET_EXTENSION_INSTALLED(state, data) {
      state.extensionInstalled = data;
    },
    SET_VERSION(state, data) {
      state.version = data;
    },
    SET_IS_ALLOWED_INCOGNITO_ACCESS(state, data) {
      state.isAllowedIncognitoAccess = data;
    },
    SET_LOCALE(state, data) {
      state.locale = data;
    },
    SET_DEPLOY_TYPE(state, data) {
      state.deployType = data;
    },
  },
  actions: {
    setLocale({ commit }, data) {
      storage.set(localeKey, data);
      commit('SET_LOCALE', data);
    },
    setVersion({ commit }, data) {
      commit('SET_VERSION', data);
    },
    setExtensionInstalled({ commit }, data) {
      commit('SET_EXTENSION_INSTALLED', data);
    },
    setIsAllowedIncognitoAccess({ commit }, data) {
      commit('SET_IS_ALLOWED_INCOGNITO_ACCESS', data);
    },
    setDeployType({ commit }, data) {
      commit('SET_DEPLOY_TYPE', data || 'saas');
    },
  },
};

export default common;
